import { SpecialCondition } from '@reliance/types/models/SpecialCondition';
import { IApiService } from '../services/api_service';

type ConditionsResponse = {
  page: number;
  perPage: number;
  total: number;
  totalPages: number;
  results: SpecialCondition[];
}

export const condition = (centralApi: IApiService) => ({
  index: (params = ({} = null)): Promise<ConditionsResponse> => {
    return centralApi.get<ConditionsResponse>(`/condition`, {
      params
    });
  }
});
